export default function downloadLocalFile(file) {
  if (file !== null) {
    const blobObject = new Blob([file]);
    // FOR IE browser use alternative option
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blobObject, file.name);
      return;
    }
    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blobObject);
    const link = document.createElement('a');
    link.href = data;
    link.download = file.name;
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100)
  }
}